import classNames from 'classnames';
import { forwardRef, useEffect } from 'react';
import styles from './style.module.scss';
import { useSelector } from 'react-redux';
import { themeEnum } from 'shared/utils/Enum';
const DropDownOptions = forwardRef(({ openSelection, setOpenSelection, options, customContainer, selectedItem, optionItemStyle, textStyle, DescStyle, IconStyle, id }, ref) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const handleClick = (e) => {
        const dropDownElem = document.getElementById(id);

        if (!ref?.current?.contains(e.target) && !dropDownElem?.contains(e.target)) {
            setOpenSelection?.(false);
        }
    };

    useEffect(() => {
        const handleDocumentClick = (event) => {
            handleClick(event);
        };

        if (openSelection) {
            document.addEventListener('click', handleDocumentClick, true);
        }

        return () => {
            document.removeEventListener('click', handleDocumentClick, true);
        };
    }, [openSelection]);

    return (
        <div
            className={classNames(`${theme}PrimaryThree`, styles.optionsContainer, customContainer && customContainer)}
            id={id}
            style={openSelection ? { display: 'flex' } : { display: 'none' }}
        >
            {options?.map((Item, inx) => {
                return (
                    <div
                        className={classNames(
                            'd-flex align-items-center gap-2 ',
                            Item?.Icon && 'py-3 px-3',
                            themeEnum.Dark == theme ? styles.OptionContainerDark : styles.OptionContainerLight,
                            optionItemStyle,
                            inx === options?.length - 1 && styles.btmradius,
                            inx === 0 && styles.topradius
                        )}
                        style={inx === options?.length - 1 ? { borderBottom: '0px' } : {}}
                        onClick={(e) => {
                            if (selectedItem) {
                                selectedItem(Item.title);
                            }
                            setOpenSelection?.(false);
                        }}
                        key={inx}
                    >
                        {Item?.Icon ? <Item.Icon className={classNames(`${theme}SvgIcon`, styles.iconStyle, IconStyle && IconStyle)} /> : null}
                        <div className={Item?.Icon ? '' : 'w-100'}>
                            <label className={classNames(`${theme}FontColor`, styles.labelStyle, Item?.Icon ? '' : 'py-3 px-3', textStyle && textStyle)}>
                                {Item?.title}
                            </label>
                            {Item?.desc ? <div className={classNames(styles.Desc, DescStyle && DescStyle)}>{Item?.desc}</div> : null}
                        </div>
                    </div>
                );
            })}
        </div>
    );
});

export default DropDownOptions;
